import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, take } from 'rxjs';

import { resolveFilterParam, toStringFilter } from '../service/search-api.utils';
import { DateFilter } from '../state/option-ids-visible/search-filter-options.models';
import { OptionLabelsFacade } from '../state/option-labels/option-labels.facade';
import { OptionsFacade } from '../state/options-facade/options.facade';

type StringFilter = { [key: string]: string[] };

@Injectable()
export class FilterResolver {
  static stringFilterParam = 'filter';
  static dateFilterParam = 'dateFilter';

  private selectedSearchFilters$: Observable<StringFilter>;
  private selectedEventDatetimeFilters$: Observable<DateFilter>;

  constructor(private searchFilterOptionsFacade: OptionsFacade, private searchFilterLabelsFacade: OptionLabelsFacade) {
    this.selectedSearchFilters$ = this.searchFilterOptionsFacade.selectedOptionIdsVisible$;
    this.selectedEventDatetimeFilters$ = this.searchFilterOptionsFacade.selectedEventDatetimeFilter$;
  }

  static equals(previous?: any, next?: any): boolean {
    return JSON.stringify(previous) === JSON.stringify(next);
  }

  resolve(route: ActivatedRouteSnapshot): boolean {
    const stringFilterParam = route.queryParamMap.get(FilterResolver.stringFilterParam);
    let stringFilter: StringFilter | undefined = undefined;
    if (stringFilterParam) {
      stringFilter = toStringFilter(resolveFilterParam(stringFilterParam));
    }
    this.selectedSearchFilters$.pipe(take(1)).subscribe((previousStringFilter) => {
      const previous = Object.entries(previousStringFilter).length !== 0 ? previousStringFilter : undefined;
      const next = stringFilter;
      if (FilterResolver.equals(previous, next)) return;
      if (next) {
        this.searchFilterOptionsFacade.onInitFilterOptions(next);
      } else {
        this.searchFilterOptionsFacade.onClearFilterOptions();
        if (previousStringFilter['exhibitor'] !== undefined) {
          this.searchFilterLabelsFacade.onRemoveExhibitorFilter();
        }
      }
    });

    const dateFilterParam = route.queryParamMap.get(FilterResolver.dateFilterParam);
    let nextDateFilter: DateFilter | undefined = undefined;
    if (dateFilterParam) {
      nextDateFilter = JSON.parse(dateFilterParam) as unknown as DateFilter;
    }
    this.selectedEventDatetimeFilters$.pipe(take(1)).subscribe((previousDateFilter) => {
      if (FilterResolver.equals(previousDateFilter, nextDateFilter)) return;
      if (nextDateFilter) {
        this.searchFilterOptionsFacade.onInitDateFilters(nextDateFilter);
      } else {
        this.searchFilterOptionsFacade.onClearDateFilters();
      }
    });

    return true;
  }
}
